<p-dialog header="{{ 'WarehousingAbnormal.Modal.AdImportFail' | translate }}" appendTo="body" [(visible)]="isVisible"
  [modal]="true" [draggable]="false" [resizable]="false" (visibleChange)="dialogVisibleChange($event)"
  [style]="{ width: '50%' }">
  <form [formGroup]="importFailForm">
    <!-- 結案/追蹤表單 -->
    <div *ngIf="loader.status | async" class="loadingMask">
          <p-progressSpinner></p-progressSpinner>
    </div>
    <div class="p-fluid grid">
      <div class="field col-6">
        <ul>
          <li>{{ 'WarehousingAbnormal.Modal.FailImportReason' | translate }}：{{
            importFailText.importFailReason }}</li>
          <li>{{ 'WarehousingAbnormal.Modal.Remarks' | translate }}：{{ importFailText.remarks }}</li>
        </ul>
      </div>
      <div class="field col-6"></div>
      <div class="field col-6">
        <div>
          <p-radioButton formControlName="handleCase" value="1"
            [label]="'WarehousingAbnormal.Modal.ContinueTracking' | translate"></p-radioButton>
          <p-radioButton class="ml-2" formControlName="handleCase" value="2"
            [label]="'WarehousingAbnormal.Modal.CloseCase' | translate"></p-radioButton>
        </div>
      </div>
    </div>
    <!-- 功能按鈕 -->
    <div class="grid">
      <div class="col">
        <button [disabled]="loader.status | async" type="button" pButton pRipple (click)="submitHandleCase()"
          title="{{ 'Common.Button.Confirm' | translate }}" label="{{ 'Common.Button.Confirm' | translate }}"></button>
        <button type="button" pButton pRipple (click)="dialogVisibleChange($event)"
          title="{{ 'Common.Button.Cancel' | translate }}" label="{{ 'Common.Button.Cancel' | translate }}"
          class="p-button-secondary ml-4"></button>
      </div>
    </div>
  </form>
</p-dialog>
